// @flow
import React, { Component } from 'react';
import {
  TextArea, Checkbox, Radio, RadioGroup, Select, Option,
} from 'informed';
import NumericText from '../../../NumericText.jsx';

import { PrimaryText, SecondaryText } from '../../../Typography.jsx';
import ContentBox from '../../../ContentBox.jsx';

import styles from '../../../../styles/patientPages/progressNote/progressNote.scss';

type Props = {
  respiratory: Object,
}

const publicUrl = process.env.PUBLIC_URL || '';

class ViewRespiratory extends Component<Props> {
  render() {
    const respiratory = this.props.respiratory || {};
    return (
      <ContentBox title='Respiratory'>
        <div className={styles.col}>
          <PrimaryText>Respiratory Assessment</PrimaryText>
          <div className={styles.section}>
            <SecondaryText>Respiratory pattern (mark all that apply):</SecondaryText><br />
            <Checkbox disabled field='respiratory.even' initialValue={respiratory.even} />Even<br />
            <Checkbox disabled field='respiratory.uneven' initialValue={respiratory.uneven} />Uneven<br />
            <Checkbox disabled field='respiratory.effortless' initialValue={respiratory.effortless} />Effortless<br />
            <Checkbox disabled field='respiratory.labored' initialValue={respiratory.labored} />Labored<br />
            <Checkbox disabled field='respiratory.deep' initialValue={respiratory.deep} />Deep<br />
            <Checkbox disabled field='respiratory.shallow' initialValue={respiratory.shallow} />Shallow<br />
            <Checkbox disabled field='respiratory.gasping' initialValue={respiratory.gasping} />Gasping<br />
            <Checkbox disabled field='respiratory.grunting' initialValue={respiratory.grunting} />Grunting<br />
            <Checkbox disabled field='respiratory.stridor' initialValue={respiratory.stridor} />Stridor<br />
            <Checkbox disabled field='respiratory.tachypneic' initialValue={respiratory.tachypneic} />Tachypneic<br />
            <Checkbox disabled field='respiratory.bradypneic' initialValue={respiratory.bradypneic} />Bradypneic
          </div>
          <div className={styles.section}>
            <SecondaryText>Respiratory effort (mark all that apply):</SecondaryText><br />
            <Checkbox disabled field='respiratory.dyspnea' initialValue={respiratory.dyspnea} />Dyspnea/shortness of breath<br />
            <Checkbox disabled field='respiratory.shortBreathOnExert' initialValue={respiratory.shortBreathOnExert} />Shortness of breath on exertion<br />
            <Checkbox disabled field='respiratory.chestExpansion' initialValue={respiratory.chestExpansion} />Increased chest expansion<br />
            <Checkbox disabled field='respiratory.orthopnea' initialValue={respiratory.orthopnea} />Orthopnea<br />
            <Checkbox disabled field='respiratory.useAccessory' initialValue={respiratory.useAccessory} />Use of accessory muscles<br />
            <Checkbox disabled field='respiratory.retractions' initialValue={respiratory.retractions} />Retractions
          </div>
          <PrimaryText>Lung Auscultation</PrimaryText>
          <div className={styles.section}>
            <img src={`${publicUrl}/sa_assets/lungs.png`} alt='lungs' width="400px" />
            <table>
              <tbody>
                <tr>
                  <td>Upper Left Anterior</td>
                  <td>
                    <Select disabled field='respiratory.upperLeftAnteriorAuscultation' initialValue={respiratory.upperLeftAnteriorAuscultation}>
                      <Option value=''>Select Value...</Option>
                      <Option value='clear'>Clear</Option>
                      <Option value='fineCrackles'>Fine crackles</Option>
                      <Option value='courseCrackles'>Course crackles</Option>
                      <Option value='rhonchi'>Ronchi</Option>
                      <Option value='rales'>Rales</Option>
                      <Option value='wheeze'>Wheeze</Option>
                      <Option value='diminished'>Diminished</Option>
                      <Option value='absent'>Absent</Option>
                    </Select>
                  </td>
                  <td>
                    <Select disabled field='respiratory.upperLeftAnteriorWheeze' initialValue={respiratory.upperLeftAnteriorWheeze}>
                      <Option value=''>Wheeze Description...</Option>
                      <Option value='inspiratory'>Inspiratory</Option>
                      <Option value='expiratory'>Expiratory</Option>
                      <Option value='throughout'>Throughout</Option>
                    </Select>
                  </td>
                </tr>
                <tr>
                  <td>Upper Right Anterior</td>
                  <td>
                    <Select disabled field='respiratory.upperRightAnteriorAuscultation' initialValue={respiratory.upperRightAnteriorAuscultation}>
                      <Option value=''>Select Value...</Option>
                      <Option value='clear'>Clear</Option>
                      <Option value='fineCrackles'>Fine crackles</Option>
                      <Option value='courseCrackles'>Course crackles</Option>
                      <Option value='rhonchi'>Ronchi</Option>
                      <Option value='rales'>Rales</Option>
                      <Option value='wheeze'>Wheeze</Option>
                      <Option value='diminished'>Diminished</Option>
                      <Option value='absent'>Absent</Option>
                    </Select>
                  </td>
                  <td>
                    <Select disabled field='respiratory.upperRightAnteriorWheeze' initialValue={respiratory.upperRightAnteriorWheeze}>
                      <Option value=''>Wheeze Description...</Option>
                      <Option value='inspiratory'>Inspiratory</Option>
                      <Option value='expiratory'>Expiratory</Option>
                      <Option value='throughout'>Throughout</Option>
                    </Select>
                  </td>
                </tr>
                <tr>
                  <td>Left Lateral</td>
                  <td>
                    <Select disabled field='respiratory.leftLateralAuscultation' initialValue={respiratory.leftLateralAuscultation}>
                      <Option value=''>Select Value...</Option>
                      <Option value='clear'>Clear</Option>
                      <Option value='fineCrackles'>Fine crackles</Option>
                      <Option value='courseCrackles'>Course crackles</Option>
                      <Option value='rhonchi'>Ronchi</Option>
                      <Option value='rales'>Rales</Option>
                      <Option value='wheeze'>Wheeze</Option>
                      <Option value='diminished'>Diminished</Option>
                      <Option value='absent'>Absent</Option>
                    </Select>
                  </td>
                  <td>
                    <Select disabled field='respiratory.leftLateralWheeze' initialValue={respiratory.leftLateralWheeze}>
                      <Option value=''>Wheeze Description...</Option>
                      <Option value='inspiratory'>Inspiratory</Option>
                      <Option value='expiratory'>Expiratory</Option>
                      <Option value='throughout'>Throughout</Option>
                    </Select>
                  </td>
                </tr>
                <tr>
                  <td>Right Lateral</td>
                  <td>
                    <Select disabled field='respiratory.rightLateralAuscultation' initialValue={respiratory.rightLateralAuscultation}>
                      <Option value=''>Select Value...</Option>
                      <Option value='clear'>Clear</Option>
                      <Option value='fineCrackles'>Fine crackles</Option>
                      <Option value='courseCrackles'>Course crackles</Option>
                      <Option value='rhonchi'>Ronchi</Option>
                      <Option value='rales'>Rales</Option>
                      <Option value='wheeze'>Wheeze</Option>
                      <Option value='diminished'>Diminished</Option>
                      <Option value='absent'>Absent</Option>
                    </Select>
                  </td>
                  <td>
                    <Select disabled field='respiratory.rightLateralWheeze' initialValue={respiratory.rightLateralWheeze}>
                      <Option value=''>Wheeze Description...</Option>
                      <Option value='inspiratory'>Inspiratory</Option>
                      <Option value='expiratory'>Expiratory</Option>
                      <Option value='throughout'>Throughout</Option>
                    </Select>
                  </td>
                </tr>
                <tr>
                  <td>Upper Left Posterior</td>
                  <td>
                    <Select disabled field='respiratory.upperLeftPosteriorAuscultation' initialValue={respiratory.upperLeftPosteriorAuscultation}>
                      <Option value=''>Select Value...</Option>
                      <Option value='clear'>Clear</Option>
                      <Option value='fineCrackles'>Fine crackles</Option>
                      <Option value='courseCrackles'>Course crackles</Option>
                      <Option value='rhonchi'>Ronchi</Option>
                      <Option value='rales'>Rales</Option>
                      <Option value='wheeze'>Wheeze</Option>
                      <Option value='diminished'>Diminished</Option>
                      <Option value='absent'>Absent</Option>
                    </Select>
                  </td>
                  <td>
                    <Select disabled field='respiratory.upperLeftPosteriorWheeze' initialValue={respiratory.upperLeftPosteriorWheeze}>
                      <Option value=''>Wheeze Description...</Option>
                      <Option value='inspiratory'>Inspiratory</Option>
                      <Option value='expiratory'>Expiratory</Option>
                      <Option value='throughout'>Throughout</Option>
                    </Select>
                  </td>
                </tr>
                <tr>
                  <td>Upper Right Posterior</td>
                  <td>
                    <Select disabled field='respiratory.upperRightPosteriorAuscultation' initialValue={respiratory.upperRightPosteriorAuscultation}>
                      <Option value=''>Select Value...</Option>
                      <Option value='clear'>Clear</Option>
                      <Option value='fineCrackles'>Fine crackles</Option>
                      <Option value='courseCrackles'>Course crackles</Option>
                      <Option value='rhonchi'>Ronchi</Option>
                      <Option value='rales'>Rales</Option>
                      <Option value='wheeze'>Wheeze</Option>
                      <Option value='diminished'>Diminished</Option>
                      <Option value='absent'>Absent</Option>
                    </Select>
                  </td>
                  <td>
                    <Select disabled field='respiratory.upperRightPosteriorWheeze' initialValue={respiratory.upperRightPosteriorWheeze}>
                      <Option value=''>Wheeze Description...</Option>
                      <Option value='inspiratory'>Inspiratory</Option>
                      <Option value='expiratory'>Expiratory</Option>
                      <Option value='throughout'>Throughout</Option>
                    </Select>
                  </td>
                </tr>
                <tr>
                  <td>Lower Left Posterior</td>
                  <td>
                    <Select disabled field='respiratory.lowerLeftPosteriorAuscultation' initialValue={respiratory.lowerLeftPosteriorAuscultation}>
                      <Option value=''>Select Value...</Option>
                      <Option value='clear'>Clear</Option>
                      <Option value='fineCrackles'>Fine crackles</Option>
                      <Option value='courseCrackles'>Course crackles</Option>
                      <Option value='rhonchi'>Ronchi</Option>
                      <Option value='rales'>Rales</Option>
                      <Option value='wheeze'>Wheeze</Option>
                      <Option value='diminished'>Diminished</Option>
                      <Option value='absent'>Absent</Option>
                    </Select>
                  </td>
                  <td>
                    <Select disabled field='respiratory.lowerLeftPosteriorWheeze' initialValue={respiratory.lowerLeftPosteriorWheeze}>
                      <Option value=''>Wheeze Description...</Option>
                      <Option value='inspiratory'>Inspiratory</Option>
                      <Option value='expiratory'>Expiratory</Option>
                      <Option value='throughout'>Throughout</Option>
                    </Select>
                  </td>
                </tr>
                <tr>
                  <td>Lower Right Posterior</td>
                  <td>
                    <Select disabled field='respiratory.lowerRightPosteriorAuscultation' initialValue={respiratory.lowerRightPosteriorAuscultation}>
                      <Option value=''>Select Value...</Option>
                      <Option value='clear'>Clear</Option>
                      <Option value='fineCrackles'>Fine crackles</Option>
                      <Option value='courseCrackles'>Course crackles</Option>
                      <Option value='rhonchi'>Ronchi</Option>
                      <Option value='rales'>Rales</Option>
                      <Option value='wheeze'>Wheeze</Option>
                      <Option value='diminished'>Diminished</Option>
                      <Option value='absent'>Absent</Option>
                    </Select>
                  </td>
                  <td>
                    <Select disabled field='respiratory.lowerRightPosteriorWheeze' initialValue={respiratory.lowerRightPosteriorWheeze}>
                      <Option value=''>Wheeze Description...</Option>
                      <Option value='inspiratory'>Inspiratory</Option>
                      <Option value='expiratory'>Expiratory</Option>
                      <Option value='throughout'>Throughout</Option>
                    </Select>
                  </td>
                </tr>
              </tbody>
            </table>
            <div>
              <SecondaryText>Respiratory pattern and breath sounds notes:</SecondaryText>
              <TextArea disabled field='respiratory.lungAuscultationNotes' initialValue={respiratory.lungAuscultationNotes} />
            </div>
          </div>
          <PrimaryText>Oxygenation</PrimaryText>
          <div className={styles.section}>
            <Checkbox disabled field='respiratory.oxygenInUse' initialValue={respiratory.oxygenInUse} />Oxygen in use<br />
            <RadioGroup field='respiratory.oxygenAmount' initialValue={respiratory.oxygenAmount}>
              <Radio disabled value='oxyL/min' />
              Amount of oxygen in L/min: <NumericText field='respiratory.oxygenLPerMin' initialValue={respiratory.oxygenLPerMin} size={4} /><br />
              <Radio disabled value='oxy%' />
              Amount of oxygen in %: <NumericText field='respiratory.oxygenPercent' initialValue={respiratory.oxygenPercent} size={4} /><br />
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>Oxygen delivery system:</SecondaryText><br />
            <RadioGroup field='respiratory.oxygenDelivery' initialValue={respiratory.oxygenDelivery}>
              <Radio disabled value='room air' />Room air<br />
              <Radio disabled value='aerosol' />Aerosol<br />
              <Radio disabled value='nasal cannula' />Nasal Cannula<br />
              <Radio disabled value='non-rebreather mask' />Non-rebreather Mask<br />
              <Radio disabled value='partial rebreather mask' />Partial Rebreather Mask<br />
              <Radio disabled value='simple mask' />Simple Mask<br />
              <Radio disabled value='venturi mask' />Venturi mask<br />
              <Radio disabled value='other' />Other
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>Oxygenation notes:</SecondaryText><br />
            <TextArea disabled field='respiratory.oxygenationNotes' initialValue={respiratory.oxygenationNotes} />
          </div>
          <div className={styles.section}>
            <SecondaryText>Respiratory/breathing support (mark all that apply):</SecondaryText><br />
            <Checkbox disabled field='respiratory.nebulizer' initialValue={respiratory.nebulizer} />Nebulizer treatment<br />
            <Checkbox disabled field='respiratory.incentiveSpiro' initialValue={respiratory.incentiveSpiro} />Incentive spirometer<br />
            Incentive spirometer best effort: <NumericText field='respiratory.incentiveSprioBest' initialValue={respiratory.incentiveSpiroBest} size={4} /> mL
          </div>
          <PrimaryText>Suctioning</PrimaryText>
          <div className={styles.section}>
            <Checkbox disabled field='respiratory.periodic' initialvalue={respiratory.periodic} />Periodic<br />
            <Checkbox disabled field='respiratory.frequentSuction' initialValue={respiratory.frequentSuction} />Frequent suctioning with bulb syringe<br />
            <SecondaryText>Amount:</SecondaryText><br />
            <RadioGroup field='respiratory.suctionAmount' initialValue={respiratory.suctionAmount}>
              <Radio disabled value='scant' />Scant<br />
              <Radio disabled value='moderate' />Moderate<br />
              <Radio disabled value='copious' />Copious<br />
              <Radio disabled value='other' />Other
            </RadioGroup>
            <br />
            <SecondaryText>Color:</SecondaryText><br />
            <RadioGroup field='respiratory.suctionColor' initialValue={respiratory.suctionColor}>
              <Radio disabled value='clear' />Clear<br />
              <Radio disabled value='white' />White<br />
              <Radio disabled value='yellow' />Yellow<br />
              <Radio disabled value='dark yellow' />Dark Yellow<br />
              <Radio disabled value='tan' />Tan<br />
              <Radio disabled value='brown' />Brown<br />
              <Radio disabled value='green' />Green<br />
              <Radio disabled value='blood-tinged' />Blood-tinged<br />
              <Radio disabled value='blood' />Blood<br />
              <Radio disabled value='other' />Other
            </RadioGroup>
            <br />
            <SecondaryText>Consistency:</SecondaryText><br />
            <RadioGroup field='respiratory.suctionConsistency' initialValue={respiratory.suctionConsistency}>
              <Radio disabled value='thin' />Thin<br />
              <Radio disabled value='frothy' />Frothy<br />
              <Radio disabled value='thick' />Thick<br />
              <Radio disabled value='other' />Other
            </RadioGroup>
            <br />
            <SecondaryText>Odor:</SecondaryText><br />
            <RadioGroup field='respiratory.suctionOdor' initialValue={respiratory.suctionOdor}>
              <Radio disabled value='none' />None<br />
              <Radio disabled value='foul' />Foul<br />
              <Radio disabled value='other' />Other
            </RadioGroup>
            <br />
            Other Suctioning Notes:<br />
            <TextArea disabled field='respiratory.otherSuctionNotes' initialValue={respiratory.otherSuctionNotes} />
          </div>
          <PrimaryText>Gag Reflex</PrimaryText>
          <div className={styles.section}>
            <table>
              <tbody className={styles.topAlign}>
                <tr>
                  <td><SecondaryText>Gag reflex:</SecondaryText></td>
                  <td>
                    <RadioGroup field='respiratory.gagReflex' initialValue={respiratory.gagReflex}>
                      <Radio disabled value='present' />Present
                      <br />
                      <Radio disabled value='not present' />Not present
                    </RadioGroup>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <PrimaryText>Cough</PrimaryText>
          <div className={styles.section}>
            <table>
              <tbody className={styles.topAlign}>
                <tr>
                  <td><SecondaryText>Cough type:</SecondaryText></td>
                  <td>
                    <RadioGroup field='respiratory.coughType' initialValue={respiratory.coughType}>
                      <Radio disabled value='none' />None<br />
                      <Radio disabled value='productive' />Productive<br />
                      <Radio disabled value='nonproductive' />Nonproductive<br />
                      <Radio disabled value='dry' />Dry<br />
                      <Radio disabled value='wet' />Wet
                    </RadioGroup>
                  </td>
                </tr>
                <tr>
                  <td><SecondaryText>Cough strength:</SecondaryText></td>
                  <td>
                    <RadioGroup field='respiratory.coughStrength' initialValue={respiratory.coughStrength}>
                      <Radio disabled value='strong' />Strong<br />
                      <Radio disabled value='weak' />Weak
                    </RadioGroup>
                  </td>
                </tr>
              </tbody>
            </table>
            <SecondaryText>Cough notes:</SecondaryText><br />
            <TextArea disabled field='respiratory.coughNotes' initialValue={respiratory.coughNotes} />
          </div>
          <PrimaryText>Productive Cough Secretions Assessment</PrimaryText>
          <div className={styles.section}>
            <SecondaryText>Amount:</SecondaryText><br />
            <RadioGroup field='respiratory.coughAmount' initialValue={respiratory.coughAmount}>
              <Radio disabled value='scant' />Scant<br />
              <Radio disabled value='moderate' />Moderate<br />
              <Radio disabled value='copious' />Copious<br />
              <Radio disabled value='other' />Other
            </RadioGroup>
            <br />
            <SecondaryText>Color:</SecondaryText><br />
            <RadioGroup field='respiratory.coughColor' initialValue={respiratory.coughColor}>
              <Radio disabled value='clear' />Clear<br />
              <Radio disabled value='white' />White<br />
              <Radio disabled value='yellow' />Yellow<br />
              <Radio disabled value='dark yellow' />Dark Yellow<br />
              <Radio disabled value='tan' />Tan<br />
              <Radio disabled value='brown' />Brown<br />
              <Radio disabled value='green' />Green<br />
              <Radio disabled value='blood-tinged' />Blood-tinged<br />
              <Radio disabled value='blood' />Blood<br />
              <Radio disabled value='other' />Other
            </RadioGroup>
            <br />
            <SecondaryText>Consistency:</SecondaryText><br />
            <RadioGroup field='respiratory.coughConsistency' initialValue={respiratory.coughConsistency}>
              <Radio disabled value='thin' />Thin<br />
              <Radio disabled value='frothy' />Frothy<br />
              <Radio disabled value='thick' />Thick<br />
              <Radio disabled value='other' />Other
            </RadioGroup>
            <br />
            <SecondaryText>Odor:</SecondaryText><br />
            <RadioGroup field='respiratory.coughOdor' initialValue={respiratory.coughOdor}>
              <Radio disabled value='none' />None<br />
              <Radio disabled value='foul' />Foul<br />
              <Radio disabled value='other' />Other
            </RadioGroup>
            <br />
            Other Cough Secretions Notes:<br />
            <TextArea disabled field='respiratory.otherCoughNotes' initialValue={respiratory.otherCoughNotes} />
          </div>
        </div>
      </ContentBox>
    );
  }
}

export default ViewRespiratory;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/progressNote/view/ViewRespiratory.jsx